<template>
    <div>
        <nav class="breadcrumb bg-white push">
            <a class="breadcrumb-item" href="javascript:void(0)">Dashboard</a>
            <span class="breadcrumb-item active">Messages</span>
        </nav>

        <div class="block">
            <div class="p-5">
                <h5>Transaction Ban Message</h5>
            </div>
            <VueEditor id="editor1" v-model="txn_ban_mail" />
            <br />
            <div class="p-10">
                <button @click.prevent="setTxnMail" class="btn btn-primary">
                    set message
                </button>
            </div>
        </div>

        <div class="block">
            <div class="p-5">
                <h5>Account registration Mail</h5>
            </div>
            <VueEditor id="editor2" v-model="registration_mail" />
            <br />
            <div class="p-10">
                <button
                    @click.prevent="setRegistrationMail"
                    class="btn btn-primary"
                >
                    set message
                </button>
            </div>
        </div>

        <!-- <div class="block">
            <div class="p-5">
                <h5>Account verification Mail</h5>
            </div>
            <VueEditor id="editor3" v-model="verification_mail" />
            <br />
            <div class="p-10">
                <button
                    @click.prevent="setVerificationMail"
                    class="btn btn-primary"
                >
                    set message
                </button>
            </div>
        </div> -->
    </div>
</template>

<script>
import { RepositoryFactory } from "../../../repository/RepositoryFactory";
import { VueEditor } from "vue2-editor";

const UsersRepository = RepositoryFactory.get("users");
export default {
    components: {
        VueEditor
    },
    data() {
        return {
            processing: false,
            accounts: [],
            txn_ban_mail: "",
            registration_mail: "",
            verification_mail: ""
        };
    },
    methods: {
        async message(data, message) {
            try {
                await UsersRepository.setNotification(data);
                this.loadSettings();
                toast.fire({
                    type: "success",
                    title: message + " ban message set successfully"
                });
            } catch (error) {
                toast.fire({
                    type: "error",
                    title: "Something went wrong"
                });
                console.log(error);
            }
        },
        async setTxnMail() {
            let data = {
                name: "txn_ban_mail",
                value: this.txn_ban_mail
            };
            await this.message(data, "Transaction");
        },
        async setRegistrationMail() {
            let data = {
                name: "registration_mail",
                value: this.registration_mail
            };
            await this.message(data, "Registration");
        },
        // async setVerificationMail() {
        //     let data = {
        //         name: "verification_mail",
        //         value: this.verification_mail
        //     };
        //     await this.message(data, "Verification");
        // },
        loadSettings() {
            UsersRepository.viewSettings().then(response => {
                let settings = response.data;
                this.verification_mail = settings[5].value;
                this.registration_mail = settings[4].value;
                this.txn_ban_mail = settings[3].value;
            });
        }
    },
    created() {
        this.loadSettings();
    }
};
</script>
